import type { FC } from 'react';

import { IconButton } from '@pp/core/src/components/controls/iconButton/IconButton';
import { HelpComponentWrapper } from '@pp/core/src/components/help/utils/HelpComponentWrapper';
import { Icons } from '@pp/core/src/components/icons/iconNames';
import { HelpText } from '@pp/core/src/services/helpTranslations/reactBindings/HelpText';
import { useConfigSlice } from '@pp/core/src/store/slices/config/selectors';

import { HIGHFLYER_PT } from '../../../config';

export const HelpChapterCrashNavigationControls: FC = () => {
  const tableVariant = useConfigSlice.getTableVariant();

  return (
    <div>
      <p>
        <HelpText tk="navigationControls.chatButton" markdown />
      </p>
      <HelpComponentWrapper>
        <IconButton icon={Icons.Chat} />
      </HelpComponentWrapper>
      <p>
        <HelpText tk="navigationControls.liveSupport" markdown />
      </p>
      <HelpComponentWrapper>
        <IconButton icon={Icons.Support} />
      </HelpComponentWrapper>
      <p>
        <HelpText tk="navigationControls.chatMessages" />
      </p>
      <p>
        <HelpText tk="navigationControls.volumeButton" markdown />
      </p>
      <HelpComponentWrapper>
        <IconButton icon={Icons.SoundOn} />
      </HelpComponentWrapper>
      <p>
        <HelpText tk="navigationControls.historyButton" markdown />
      </p>
      <HelpComponentWrapper>
        <IconButton icon={Icons.History} />
      </HelpComponentWrapper>
      <p>
        <HelpText tk="navigationControls.gameRound" />
      </p>
      <p>
        <HelpText tk="navigationControls.gameHelp" markdown />
      </p>
      <HelpComponentWrapper>
        <IconButton icon={Icons.Help} />
      </HelpComponentWrapper>
      <p>
        <HelpText tk="navigationControls.settingsButton" markdown />
      </p>
      <HelpComponentWrapper>
        <IconButton icon={Icons.Settings} />
      </HelpComponentWrapper>
      <ul>
        <li>
          <HelpText tk="navigationControls.animation" />
        </li>
        <li>
          <HelpText tk="navigationControls.gameEffects" />
        </li>
        <li>
          <HelpText tk="navigationControls.bettingGrid" />
        </li>
        {tableVariant !== HIGHFLYER_PT ? null : (
          <li>
            <HelpText tk="navigationControls.hideBetDetails" />
          </li>
        )}
      </ul>
      <p>
        <HelpText tk="navigationControls.fullScreen" markdown />
      </p>
      <HelpComponentWrapper>
        <IconButton icon={Icons.FullscreenEnter} />
      </HelpComponentWrapper>
    </div>
  );
};
